import { useState } from 'react';
import UsersTable from '../components/UsersTable';
import AnswersTable from '../components/AnswersTable';
import CustomerSupport from '../components/CustomerSupport';
import { useUserData } from '../hooks/useUserData';

function ExpandableSection({ title, children, defaultExpanded = false }) {
  const [isExpanded, setIsExpanded] = useState(defaultExpanded);

  return (
    <div
      style={{
        marginBottom: '16px',
        background: '#fff',
        borderRadius: '8px',
        border: '1px solid #e5e7eb',
        overflow: 'hidden',
      }}
    >
      <button
        onClick={() => setIsExpanded(!isExpanded)}
        style={{
          width: '100%',
          display: 'flex',
          flexDirection: 'row',
          alignItems: 'center',
          justifyContent: 'space-between',
          padding: '16px 20px',
          background: 'transparent',
          border: 'none',
          cursor: 'pointer',
          textAlign: 'left',
        }}
      >
        <span style={{ fontSize: '16px', fontWeight: 600, color: '#1f2937' }}>
          {title}
        </span>
        <span
          style={{
            fontSize: '12px',
            color: '#6b7280',
            transition: 'transform 0.2s',
            transform: isExpanded ? 'rotate(180deg)' : 'rotate(0deg)',
          }}
        >
          ▼
        </span>
      </button>
      {isExpanded && (
        <div style={{ padding: '0 20px 20px', borderTop: '1px solid #f3f4f6' }}>
          {children}
        </div>
      )}
    </div>
  );
}

function AdminPage() {
  const { userData } = useUserData();

  if (userData?.accessLevel !== 'admin') {
    return null;
  }

  return (
    <div className="mt-4">
      <ExpandableSection title="Customer Support">
        <CustomerSupport />
      </ExpandableSection>
      <ExpandableSection title="Answers Table">
        <AnswersTable />
      </ExpandableSection>
      <UsersTable />
    </div>
  );
}

export default AdminPage;
